import { useMemo } from "react";
import { getGroupTeeth, sortByFirstTooth } from "../productGroupTeeth";
import type { ConfigurableProduct } from "../steps/types";

export type ProductGroup = {
  product: ConfigurableProduct;
  groupProducts: ConfigurableProduct[];
  groupTeeth: number[];
};

/**
 * What a step reads of the products it configures: the first one, all of them
 * by first tooth and all their teeth.
 */
export const useProductGroup = (
  products: ConfigurableProduct[]
): ProductGroup =>
  useMemo(
    () => ({
      product: products[0],
      groupProducts: sortByFirstTooth(products),
      groupTeeth: getGroupTeeth(products),
    }),
    [products]
  );
